import { CircularProgress } from "@mui/material"

const loaderStyle = {
    width: "100%",
    maxWidth: 360,
    bgColor: "background.paper",
    align: "center",
};

export const CustomCircularProgress = () => {
    return <CircularProgress color="primary" sx={loaderStyle} />
}